
  const processWorksheet = {
    path: "/processWorksheet/view/:id",
    name: "processWorksheetView",
    component: () => import(/* webpackChunkName: "process_worksheet_view" */ "@/components/processWorksheet/ProcessWorksheetView.vue"),
    meta: { authorize: [], requiresAuth: true }
  };

export default processWorksheet;
    